import Link from 'next/link';
import { useRouter } from 'next/router';

import useStyles from './style-zero-results';
import { ReactComponent as ZeroResultsIcon } from './zero-results.svg';

function EmojisZeroResults() {
  const styles = useStyles();
  const { asPath } = useRouter();
  const isHomeRoute = asPath === '/';

  return (
    <div className={styles.root}>
      <div className={styles.box}>
        <div className={styles.icon}>
          <ZeroResultsIcon />
        </div>
        <h6 className={styles.title}>No results found</h6>

        <p className={styles.message}>
          {isHomeRoute ? (
            <>Make sure the spelling is correct or try using a different keyword.</>
          ) : (
            <>
              Nothing came up for the category you selected. <br />
              Try searching all categories instead.
            </>
          )}
        </p>

        {!isHomeRoute && (
          <Link href="/" passHref>
            <a className={styles.button}>Search all categories</a>
          </Link>
        )}
      </div>
    </div>
  );
}

export default EmojisZeroResults;
